import createCache from "@emotion/cache";
import { getClientNonce } from "../helpers/policies";

export default function createEmotionCache(nonce: string) {
  return createCache({
    key: "css",
    nonce: nonce || getClientNonce(),
    prepend: true,
  });
}
